import { render } from "./ConversationFooter.vue.js?vue&type=template&id=1ae98e6a&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationFooter.vue?vue&type=template&id=1ae98e6a&scoped=true"
import script from "./ConversationFooter.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationFooter.vue?vue&type=script&lang=js"
export * from "./ConversationFooter.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationFooter.vue?vue&type=script&lang=js"

import "./ConversationFooter.vue.scss?vue&type=style&index=0&id=1ae98e6a&scoped=true&lang=scss!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationFooter.vue?vue&type=style&index=0&id=1ae98e6a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae98e6a"],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/ConversationFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ae98e6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ae98e6a', __exports__)) {
    api.reload('1ae98e6a', __exports__)
  }
  
  module.hot.accept("./ConversationFooter.vue.js?vue&type=template&id=1ae98e6a&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ConversationFooter.vue?vue&type=template&id=1ae98e6a&scoped=true", () => {
    api.rerender('1ae98e6a', render)
  })

}


export default __exports__